import { createContext } from 'react';
const PortalContactsContext = /*#__PURE__*/createContext(null);
export default PortalContactsContext;